module.exports = __webpack_public_path__ + "img/startupLoad.4015a22.svg";